import axios from 'axios'
import { HTTP } from 'types'
import { ICAS_API_KEY, ICAS_API_URL, config } from './_utils'

// #region BUSINESS AKA WORKSPACE

export const workspaceApi = {
  create: (formValues, params = {}) =>
    axios.post(
      `${ICAS_API_URL}/v2/businesses/`,
      formValues,
      config({
        params,
        apiKey: ICAS_API_KEY,
        contentType: HTTP.ContentTypes.JSON,
      })
    ),
  inviteMember: (businessSlug, formValues, params) =>
    axios.post(
      `${ICAS_API_URL}/v2/businesses/${businessSlug}/invitations/`,
      formValues,
      config({
        params,
        apiKey: ICAS_API_KEY,
        contentType: HTTP.ContentTypes.JSON,
      })
    ),

  getMembers: (businessSlug, params) =>
    axios.get(
      `${ICAS_API_URL}/v2/businesses/${businessSlug}/members/`,
      config({ apiKey: ICAS_API_KEY, params })
    ),

  deleteMember: (businessSlug, username, formValues, params) =>
    axios.delete(
      `${ICAS_API_URL}/v2/businesses/${businessSlug}/members/${username}/`,
      config({
        params,
        data: formValues,
        apiKey: ICAS_API_KEY,
        contentType: HTTP.ContentTypes.JSON,
      })
    ),
  deleteInvitation: (businessSlug, invitationKey, params) =>
    axios.delete(
      `${ICAS_API_URL}/v2/businesses/${businessSlug}/invitations/${invitationKey}/`,
      config({
        params,
        apiKey: ICAS_API_KEY,
        contentType: HTTP.ContentTypes.JSON,
      })
    ),
  getAllInvitations: (businessSlug, params) =>
    axios.get(
      `${ICAS_API_URL}/v2/businesses/${businessSlug}/invitations/`,
      config({ apiKey: ICAS_API_KEY, params })
    ),
}

// #endregion BUSINESS
